import styled from "styled-components";
import HeaderMobile from '~/components/layout/HeaderOld';

export const PageContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: #ffffff;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row;
  background-color: #ffffff;

  @media (max-width: 770px) {
    height: 100%;
    overflow-y: hidden;
    padding: 0;
  }

  @media(min-width: 770px) {
    display: block;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;
  margin-bottom: 30px;
  @media (max-width: 770px) {
    padding: 0;
    display: none;
  }
`;

export const HeaderContent = styled.div`
  @media(min-width: 770px) {
    display: none;
  }
`;

export const CloseIconContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 20px;
`;

export const CloseIcon = styled.div`
  font-size: 28px;
  color: #808080;
  cursor: pointer;
`;

export const PageTitleContainer = styled.div`
  width: 100%;
  margin-top: -10px;
  padding: 0px 20px;
`;

export const PageIcon = styled.img`
  width: 30px;
  margin-right: 10px;
`;

export const PageTitle = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const PageContent = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const Content = styled.div`
  height: 95%;
  width: 100%;
  padding: 0 100px;

  @media (min-width: 768px) and (max-width: 1360px) {
    padding: 0 50px;
  }

  @media (max-width: 768px) {
    height: 100vh;
    width: 100%;
    padding: 0;
  }
`;

export const WrapperInvoices = styled.div`
  height: 89%;
  width: 100%;
  margin-top: -20px;
  overflow-y: scroll;

  @media (max-width: 770px) {
    margin-top: 0px;
  }
`;

export const FielterContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;

  @media(max-width: 770px) {
    flex-wrap: wrap;
  }
`;

export const FielterButton = styled.div`
  width: auto;
  height: auto;
  padding: 7px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #d6d6d6;
  border-radius: 50px;
  color: #808080;
  font-size: 13px;
  margin-bottom: 30px;
  margin-right: 20px;
  cursor: pointer;

  ${props => props.active && 'background-color: #000FFF'};
  ${props => props.active && 'border: 1px solid #000FFF'};
  ${props => props.active && 'color: #ffffff'};

  @media(max-width: 770px) {
    margin-bottom: 20px;
  }
`;

export const ContractTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const DivisionItems = styled.div`
`;

export const DesktopContainer = styled.div`
  @media(min-width: 770px) {
    display: block;
  }

  @media(max-width: 770px) {
    display: none;
  }
`;

export const MobileContainer = styled.div`
  @media(min-width: 770px) {
    display: none;
  }

  @media(max-width: 770px) {
    display: block;
  }
`;

export const DivisionCardHeader = styled.div`
  display: flex;
  justify-content: space-between;

  span {
    margin-left: 1rem;
    padding: .75rem 0;
    color: #808080;
  }
`;

export const WhiteDivision = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  background-color: white;
  padding: .75rem 0;

  img {
    transform: rotate(180deg);
  }
`;

export const GrayDivision = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  background-color: #A5A5A5;
  padding: .75rem 0;
`;

export const AlignNoVoucher = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.6rem;

  @media(max-width: 770px) {
    margin: 1rem;
  }

  span {
    color: #808080;
  }
`;
